import { Directive } from '@angular/core';

@Directive({
  selector: '[Webview]'
})
export class WebviewDirective {

  constructor() { }

}



// WEBPACK FOOTER //
// /root/production/sne-pro/src/app/directives/webview.directive.ts